import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=7fbae79d"
import script from "./YouTube.vue?vue&type=script&lang=js"
export * from "./YouTube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports